import { render } from "./app-icon-small-logo-with-border.vue?vue&type=template&id=51d599b8"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-small-logo-with-border.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51d599b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51d599b8', __exports__)) {
    console.log('reload')
    api.reload('51d599b8', __exports__)
  }
  
  module.hot.accept("./app-icon-small-logo-with-border.vue?vue&type=template&id=51d599b8", () => {
    console.log('re-render')
    api.rerender('51d599b8', render)
  })

}


export default __exports__